<template>
  <v-layout>
    <div class="padding-container-lg">
      <!-- <v-page-header>
        <span slot="header">
          Create User
        </span>
      </v-page-header> -->
      <div>
        <form @submit.prevent="validateBeforeSubmit">
          <div class="row pb-4">
            <div class="col col-md-6 col-12">
              <div class="form-group">
                <label for="user-first_name">First Name</label>
                <b-form-input
                  v-model="user.first_name"
                  v-validate="'required'"
                  :class="{'danger': errors.has('firstName') }"
                  name="firstName"
                  type="text"
                  placeholder="Enter your first name"
                />
                <!-- <span
                  v-show="errors.has('user first_name')"
                  class="error-text">Required</span> -->
              </div>
            </div>
            <div class="col col-md-6 col-12">
              <div class="form-group">
                <label for="lastName">Last Name</label>
                <b-form-input
                  v-model="user.last_name"
                  v-validate="'required'"
                  :class="{'danger': errors.has('lastName') }"
                  name="lastName"
                  class="col-12"
                  placeholder="Enter your last name"
                />
              </div>
            </div>
            <div class="col col-md-6 col-12 row m-0 p-0">
              <div class="col col-md-6 col-12">
                <div class="form-group">
                  <label for="gender">Gender</label>
                  <b-form-select
                    v-model="user.gender"
                    v-validate="'required'"
                    :class="{'danger': errors.has('gender') }"
                    class="form-control"
                    name="gender"
                    :options="genders"
                  />
                </div>
              </div>
              <div class="col col-md-6 col-12 fl-left">
                <v-date-picker
                  :label="`Date of birth`"
                  v-validate="'required'"
                  :maxDate="getFormattedDate(new Date())"
                  :value="defaultDateFormat(user.dob)"
                  @onChange="(value) => user.dob = value"
                  :className="{'danger': errors.has('dob')}"
                  name="dob"
                  position="bottom"
                />
              </div>
            </div>
            <div class="col col-md-6 col-12">
              <div class="form-group">
                <label for="email">Email</label>
                <b-form-input
                  v-model="user.email"
                  v-validate="'required|email'"
                  :class="{'danger': errors.has('email') }"
                  class="form-control"
                  name="email"
                  placeholder="Enter email"
                />
              </div>
            </div>

            <div class="col col-md-6 col-12">
              <!-- |digits:${10} can be used-->
              <v-mobile-input
                :value="user.mobile_no"
                :countryCode="user.country_code"
                v-model="user.mobile_no"
                :label="`Mobile Number`"
                v-validate="'required'"
                :className="{'danger': errors.has('mobileNumber') }"
                @onChange="onMobileInputChange"
                name="mobileNumber"
                type="number"
                placeholder="Enter MobileNumber"
              />
             <span class="text-danger" v-if="!isMobileNumberValid"><small>The mobileNumber must be a valid mobile number</small></span>
            </div>
            <div class="col col-md-6 col-12">
              <div class="form-group">
                <label for="designation">Designation</label>
                <b-form-select
                  v-model="user.designation"
                  v-validate="'required'"
                  :class="{'danger': errors.has('designation') }"
                  class="form-control"
                  name="designation"
                  :options="designations"
                />
              </div>
            </div>
            <div class="col col-md-6 col-12">
              <div class="form-group">
                <label>Address</label>
                <textarea
                  class="form-control"
                  placeholder="address"
                  v-validate="'required'"
                  v-model="user.address"
                  :class="{'danger': errors.has('address') }"
                  name="address"
                />
              </div>
            </div>
            <div class="col text-right col-12">
              <b-button
                type="submit"
                variant="primary"
              >Create User
              </b-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </v-layout>
</template>

<script>
import VLayout from '@/layouts/Default.vue';
// import VPageHeader from '@/components/pageheader/PageHeader.vue';
import VMobileInput from '@/components/baseComponents/BaseMobileInput.vue';
import { mapGetters } from 'vuex';
import roles from '@/constants/_roles';

export default {
  name: 'CreateUser',
  components: { VLayout, VMobileInput },
  data() {
    return {
      resetUser: false,
      isEnableClick: false,
      isMobileNumberValid: true,
      user: {
        first_name: '',
        last_name: '',
        email: '',
        mobile_no: '',
        gender: null,
        dob: '',
        designation: '',
        address: '',
        profile_image_url: '',
        country_code: '',
        username: ''
      },
      genders: [
        {
          value: null,
          text: 'Select a Gender'
        },
        {
          value: 'male',
          text: 'Male'
        },
        {
          value: 'female',
          text: 'Female'
        }
      ],
      designations: [
        {
          value: null,
          text: 'Select a Role'
        },
        {
          value: roles.CARE_AUTHOR,
          text: 'Care Author'
        },
        {
          value: roles.CARE_NAVIGATOR,
          text: 'Care Navigator'
        },
        {
          value: roles.FIRST_RESPONDER,
          text: 'Initial Call Receiver'
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      organisationId: 'auth/getOrganisationId',
      loading: 'user/getLoading'
    })
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result && this.user.mobile_no && this.isMobileNumberValid) {
          this.user.email = this.user.email.toLowerCase();
          const data = this.user;
          data.role = {
            [data.role]: data.role
          };
          data.organisation_id = this.organisationId;
          this.$store.dispatch('user/create', data);
        }
      });
    },
    onMobileInputChange({ isValid, country }, mobileNumber) {
      this.isMobileNumberValid = isValid;
      this.user.mobile_no = mobileNumber;
      this.user.country_code = country.dialCode;
    },
    editUser() {
      this.$router.push({
        name: 'user.edit',
        params: { id: this.user.id }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
